module.exports = __webpack_public_path__ + "static/media/Bluelab External Lockout and Alarm Box.b7beabff.webp";